import { ComponentStoreV2Factory } from '../../../../modules/shared/store/common/component-store-v2.factory';
import { computed, Injectable } from '@angular/core';
import { routeParams } from '../../../../modules/shared/shared.global-service';

@Injectable()
export class ServiceSettingDashboardPageStore extends ComponentStoreV2Factory {

    public service = computed(() => this.globalGlobalStore.organizationStore.getServiceBySignalId(routeParams.serviceId)());

}
